import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LanguageService } from '../../../tms-shared';
import { AuthService, IUser } from '../../services';
import { ApplicationPaths } from '../../constants';

@Component({
  selector: 'app-login-menu',
  styleUrl: 'login-menu.component.scss',
  templateUrl: 'login-menu.component.html',
  imports: [RouterLink, AsyncPipe],
})
export class LoginMenuComponent implements OnInit {
  protected readonly languageService = inject(LanguageService);
  protected readonly authService = inject(AuthService);

  public readonly isScannerApp = input(false);

  protected readonly ApplicationPaths = ApplicationPaths;

  public isAuthenticated$: Observable<boolean>;
  public userName$: Observable<string>;

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    this.getUserName();
  }

  private getUserName() {
    this.userName$ = this.authService.getUser().pipe(
      map((u: IUser) => {
        if (!u) {
          return '';
        }
        const fullName = (u.full_name ?? u.name)?.replace(' @', '@') ?? '';
        const supplierName = u.supplier_name ? ` - ${u.supplier_name}` : '';
        return `${fullName}${supplierName}`;
      }),
    );
  }

  translateMenu(value: string) {
    switch (value) {
      case 'Log in':
        return $localize`Log in`;
      case 'Log out':
        return $localize`Log out`;
      default:
        return '';
    }
  }
}
